import { useParams } from 'react-router-dom'
import { BillingTypeBuyModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeBuy'
import { useMemo } from 'react'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import DoubleTable from '../../../../../../baseComponents/DoubleTable'
import { useAddDoubleTableGreenRowRender } from '../../../../../../baseComponents/DoubleTable/functions'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import ConfigBillingTypeBuyOptions from './ConfigBillingTypeBuyOptions'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import ModalCEConfigBillingTypeBuy from './ModalCEConfigBillingTypeBuy'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { CustomRenderBoolean, EditRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import ConfigBillingTypeBuySortButton from './ConfigBillingTypeBuySortButton'
import locations from '../../../../../../utils/globals/locations'


interface ConfigBillingTypesBuyProps extends ComponentWithPermissions { }

const ConfigBillingTypesBuy: React.FC<ConfigBillingTypesBuyProps> = ({ userPermissions }) => {
    const { BillingTypeBuyId } = useParams()
    return (<DoubleTable userPermissions={userPermissions} FirstChild={BillingTypesBuy} SecondChild={ConfigBillingTypeBuyOptions} displaySecond={BillingTypeBuyId !== 'main'} />)
}


interface BillingTypesBuyProps extends ComponentWithPermissions { }

const BillingTypesBuy: React.FC<BillingTypesBuyProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('billingTypeBuy', 'Tipos de Facturación'),
        newText: t('newBillingTypeBuy', 'Nuevo Tipos de Facturación'),
    }

    return (
        <BaseScreenTable TableComponent={TableBillingTypesBuy} CreateModalComponent={ModalCEConfigBillingTypeBuy} EditModalComponent={ModalCEConfigBillingTypeBuy} pageData={pageData} userPermissions={userPermissions} />
    )
}

type TableBillingTypesBuyProps = TableComponentProps & {}

const TableBillingTypesBuy: React.FC<TableBillingTypesBuyProps> = ({ userPermissions, setTableInstance, setOpened, tableInstance }) => {
    const { t } = useTwinTranslation()
    const { BillingGroupId, BillingTypeBuyId } = useParams()
    const { rowRenderer } = useAddDoubleTableGreenRowRender(BillingTypeBuyId || '')

    const columns: ColumnTableSchema<BillingTypeBuyModelType> = [
        {
            id: 'order',
            dataKey: 'order',
            label: t('order', 'Order'),
            sortable: true,
            width: 100
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'mandatory',
            dataKey: 'mandatory',
            label: t('mandatory', 'Obligatorio'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={75} />,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
    ]
    const children = useMemo(() => <ConfigBillingTypeBuySortButton tableInstance={tableInstance} userPermissions={userPermissions} />, [tableInstance, userPermissions])

    return (
        <TwinTableLink name='billingTypesBuy' extraWhereParams={{ BillingGroupId }} columns={columns} getDataFrom='/api/app/config/billingGroup/billingTypeBuy/getAllBillingTypesBuy' rowRenderer={rowRenderer} setTableInstance={setTableInstance} createRowDataLink={[locations.configBillingTypeBuy, [String(BillingGroupId || ''), '$id']]} defaultOrder={{ defaultOrderField: 'order', order: 'asc' }} hideLoadFiltersButton={true} >
            {children}
        </TwinTableLink>
    )
}


export default ConfigBillingTypesBuy